import { useRef } from "react";
import { useInView as useInViewFromFramer } from "framer-motion";

export default function useInView({ once = true, margin = "-30px 0px 0px 0px" } = {}) {
  const ref = useRef(null);
  const isInView = useInViewFromFramer(ref, {
    once: once,
    margin: margin, // Ensure margin is included
  });

  return [ref, isInView];
}
